import { useCallback } from 'react';
import { prop } from 'ramda';

import { useDeviceSelector } from '@core/js/store/hooks';

import { useGetRetailConfigTag } from '@interlayer/js/app/hooks/useGetRetailConfigFlow';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { addZeroToStart } from '@interlayer/js/app/utils/methods.util';
import { getUtmCookie } from '@interlayer/js/components/system/App/buzz/hooks/useSetUTMCookie';

export const useGetUtmField = () => {
    const { config: { customFieldNumberUtm } } = useRegistrationSelector();
    const isUpgrade = useRegistrationSelector(prop('isUpgrade'));
    const formFactor = useDeviceSelector(prop('formFactor'));
    const retailPagesConfig = useGetRetailConfigTag();

    return useCallback((hallCode?: string) => {
        const utmValue: Record<string, string> = {};

        const customFieldValueUtm = getUtmCookie();

        if (customFieldNumberUtm && customFieldValueUtm) {
            utmValue[`custom${addZeroToStart(customFieldNumberUtm)}`] = customFieldValueUtm;
        } else if (retailPagesConfig?.overrideUtm) {
            const source = isUpgrade
                ? retailPagesConfig?.upgradeUtmSource || 'CFS_RetailUpgrade'
                : retailPagesConfig?.registerUtmSource || 'CFS_RetailNew';

            utmValue.custom05 = new URLSearchParams({
                source,
                medium: formFactor,
                content: hallCode || ''
            }).toString();
        }

        return utmValue;
    }, [
        customFieldNumberUtm, formFactor, isUpgrade, retailPagesConfig?.overrideUtm,
        retailPagesConfig?.registerUtmSource, retailPagesConfig?.upgradeUtmSource
    ]);
};
